/*
 * The activities component holds logic to display published activities.
 */

import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@components/base/base.component';
import { BaseService } from '@services/base/base.service';
import { ActivitiesService } from '@services/activities/activities.service';

@Component({
    selector: 'app-component-activities',
    templateUrl: 'activities.component.html',
    styleUrls: ['activities.component.less']
})
export class ActivitiesComponent extends BaseComponent implements OnInit {

    constructor(
        public baseService: BaseService,
        private activitiesService: ActivitiesService
    ) {
        super(baseService);
    }

    ngOnInit() {
        this.item = this.activitiesService.get('name,claim,description,advantages,image_landscape,image_portrait,image_square,slug,classes,translations.*');
    }
}